// Who is driving this session.
//
// The public tour pages are buyer-facing. Measure, sticky notes, the PDF report,
// copresence, the session dashboard and the yaw/pitch HUD are operator tools
// that were sharing a row with "share" and "sound"; they now need ?operator=1.
//
// ?edit=1 and ?embed=1 imply operator, because someone authoring a tour is by
// definition an operator — and the embedded editor needs the measure tool.

import type { AudienceFlags, MenuAudience } from './types.ts';

const OPERATOR_PARAM = 'operator';

export function resolveAudience(search: string = window.location.search): AudienceFlags {
  const params = new URLSearchParams(search);
  const editor = isTruthy(params.get('edit')) || isTruthy(params.get('embed'));
  return {
    operator: editor || isTruthy(params.get(OPERATOR_PARAM)),
    editor,
    embedded: isTruthy(params.get('embed')),
  };
}

/** `?operator=1`, `?operator`, `?operator=true` all count; `?operator=0` does not. */
function isTruthy(value: string | null): boolean {
  if (value === null) return false;
  return value !== '0' && value !== 'false';
}

export function audienceAllows(audience: MenuAudience, flags: AudienceFlags): boolean {
  if (audience === 'buyer') return true;
  if (audience === 'operator') return flags.operator;
  return flags.editor;
}
